module.exports = __webpack_public_path__ + "img/gmw.f9b950a9.png";